import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import type { RootState, AppDispatch } from '../store';
import { loadAyah } from '../store/slices/ayahSlice';
import { clearEvaluation } from '../store/slices/evaluationSlice';
import { reset as resetRecitation } from '../store/slices/recitationSlice';

const SURAHS = [
  { number: 1, name: 'Al-Fatiha', ayahs: 7 },
  { number: 2, name: 'Al-Baqarah', ayahs: 286 },
  { number: 3, name: 'Aal-Imran', ayahs: 200 },
  { number: 4, name: 'An-Nisa', ayahs: 176 },
  { number: 5, name: 'Al-Maidah', ayahs: 120 },
  { number: 6, name: 'Al-Anam', ayahs: 165 },
  { number: 7, name: 'Al-Araf', ayahs: 206 },
  { number: 8, name: 'Al-Anfal', ayahs: 75 },
  { number: 9, name: 'At-Tawbah', ayahs: 129 },
  { number: 10, name: 'Yunus', ayahs: 109 },
  { number: 11, name: 'Hud', ayahs: 123 },
  { number: 12, name: 'Yusuf', ayahs: 111 },
  { number: 13, name: 'Ar-Rad', ayahs: 43 },
  { number: 14, name: 'Ibrahim', ayahs: 52 },
  { number: 15, name: 'Al-Hijr', ayahs: 99 },
  { number: 16, name: 'An-Nahl', ayahs: 128 },
  { number: 17, name: 'Al-Isra', ayahs: 111 },
  { number: 18, name: 'Al-Kahf', ayahs: 110 },
  { number: 19, name: 'Maryam', ayahs: 98 },
  { number: 20, name: 'Ta-Ha', ayahs: 135 },
  { number: 21, name: 'Al-Anbiya', ayahs: 112 },
  { number: 22, name: 'Al-Hajj', ayahs: 78 },
  { number: 23, name: 'Al-Muminun', ayahs: 118 },
  { number: 24, name: 'An-Nur', ayahs: 64 },
  { number: 25, name: 'Al-Furqan', ayahs: 77 },
  { number: 26, name: 'Ash-Shuara', ayahs: 227 },
  { number: 27, name: 'An-Naml', ayahs: 93 },
  { number: 28, name: 'Al-Qasas', ayahs: 88 },
  { number: 29, name: 'Al-Ankabut', ayahs: 69 },
  { number: 30, name: 'Ar-Rum', ayahs: 60 },
  { number: 31, name: 'Luqman', ayahs: 34 },
  { number: 32, name: 'As-Sajdah', ayahs: 30 },
  { number: 33, name: 'Al-Ahzab', ayahs: 73 },
  { number: 34, name: 'Saba', ayahs: 54 },
  { number: 35, name: 'Fatir', ayahs: 45 },
  { number: 36, name: 'Ya-Sin', ayahs: 83 },
  { number: 37, name: 'As-Saffat', ayahs: 182 },
  { number: 38, name: 'Sad', ayahs: 88 },
  { number: 39, name: 'Az-Zumar', ayahs: 75 },
  { number: 40, name: 'Ghafir', ayahs: 85 },
  { number: 41, name: 'Fussilat', ayahs: 54 },
  { number: 42, name: 'Ash-Shura', ayahs: 53 },
  { number: 43, name: 'Az-Zukhruf', ayahs: 89 },
  { number: 44, name: 'Ad-Dukhan', ayahs: 59 },
  { number: 45, name: 'Al-Jathiyah', ayahs: 37 },
  { number: 46, name: 'Al-Ahqaf', ayahs: 35 },
  { number: 47, name: 'Muhammad', ayahs: 38 },
  { number: 48, name: 'Al-Fath', ayahs: 29 },
  { number: 49, name: 'Al-Hujurat', ayahs: 18 },
  { number: 50, name: 'Qaf', ayahs: 45 },
  { number: 51, name: 'Adh-Dhariyat', ayahs: 60 },
  { number: 52, name: 'At-Tur', ayahs: 49 },
  { number: 53, name: 'An-Najm', ayahs: 62 },
  { number: 54, name: 'Al-Qamar', ayahs: 55 },
  { number: 55, name: 'Ar-Rahman', ayahs: 78 },
  { number: 56, name: 'Al-Waqiah', ayahs: 96 },
  { number: 57, name: 'Al-Hadid', ayahs: 29 },
  { number: 58, name: 'Al-Mujadila', ayahs: 22 },
  { number: 59, name: 'Al-Hashr', ayahs: 24 },
  { number: 60, name: 'Al-Mumtahanah', ayahs: 13 },
  { number: 61, name: 'As-Saff', ayahs: 14 },
  { number: 62, name: 'Al-Jumuah', ayahs: 11 },
  { number: 63, name: 'Al-Munafiqun', ayahs: 11 },
  { number: 64, name: 'At-Taghabun', ayahs: 18 },
  { number: 65, name: 'At-Talaq', ayahs: 12 },
  { number: 66, name: 'At-Tahrim', ayahs: 12 },
  { number: 67, name: 'Al-Mulk', ayahs: 30 },
  { number: 68, name: 'Al-Qalam', ayahs: 52 },
  { number: 69, name: 'Al-Haqqah', ayahs: 52 },
  { number: 70, name: 'Al-Maarij', ayahs: 44 },
  { number: 71, name: 'Nuh', ayahs: 28 },
  { number: 72, name: 'Al-Jinn', ayahs: 28 },
  { number: 73, name: 'Al-Muzzammil', ayahs: 20 },
  { number: 74, name: 'Al-Muddaththir', ayahs: 56 },
  { number: 75, name: 'Al-Qiyamah', ayahs: 40 },
  { number: 76, name: 'Al-Insan', ayahs: 31 },
  { number: 77, name: 'Al-Mursalat', ayahs: 50 },
  { number: 78, name: 'An-Naba', ayahs: 40 },
  { number: 79, name: 'An-Naziat', ayahs: 46 },
  { number: 80, name: 'Abasa', ayahs: 42 },
  { number: 81, name: 'At-Takwir', ayahs: 29 },
  { number: 82, name: 'Al-Infitar', ayahs: 19 },
  { number: 83, name: 'Al-Mutaffifin', ayahs: 36 },
  { number: 84, name: 'Al-Inshiqaq', ayahs: 25 },
  { number: 85, name: 'Al-Buruj', ayahs: 22 },
  { number: 86, name: 'At-Tariq', ayahs: 17 },
  { number: 87, name: 'Al-Ala', ayahs: 19 },
  { number: 88, name: 'Al-Ghashiyah', ayahs: 26 },
  { number: 89, name: 'Al-Fajr', ayahs: 30 },
  { number: 90, name: 'Al-Balad', ayahs: 20 },
  { number: 91, name: 'Ash-Shams', ayahs: 15 },
  { number: 92, name: 'Al-Layl', ayahs: 21 },
  { number: 93, name: 'Ad-Duha', ayahs: 11 },
  { number: 94, name: 'Ash-Sharh', ayahs: 8 },
  { number: 95, name: 'At-Tin', ayahs: 8 },
  { number: 96, name: 'Al-Alaq', ayahs: 19 },
  { number: 97, name: 'Al-Qadr', ayahs: 5 },
  { number: 98, name: 'Al-Bayyinah', ayahs: 8 },
  { number: 99, name: 'Az-Zalzalah', ayahs: 8 },
  { number: 100, name: 'Al-Adiyat', ayahs: 11 },
  { number: 101, name: 'Al-Qariah', ayahs: 11 },
  { number: 102, name: 'At-Takathur', ayahs: 8 },
  { number: 103, name: 'Al-Asr', ayahs: 3 },
  { number: 104, name: 'Al-Humazah', ayahs: 9 },
  { number: 105, name: 'Al-Fil', ayahs: 5 },
  { number: 106, name: 'Quraysh', ayahs: 4 },
  { number: 107, name: 'Al-Maun', ayahs: 7 },
  { number: 108, name: 'Al-Kawthar', ayahs: 3 },
  { number: 109, name: 'Al-Kafirun', ayahs: 6 },
  { number: 110, name: 'An-Nasr', ayahs: 3 },
  { number: 111, name: 'Al-Masad', ayahs: 5 },
  { number: 112, name: 'Al-Ikhlas', ayahs: 4 },
  { number: 113, name: 'Al-Falaq', ayahs: 5 },
  { number: 114, name: 'An-Nas', ayahs: 6 },
];

const ChevronLeft = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
  </svg>
);

const ChevronRight = () => (
  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
  </svg>
);

const AyahSelector: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { selectedSurah, selectedAyah, totalAyahs, loading } = useSelector(
    (state: RootState) => state.ayah
  );
  const [surahPickerOpen, setSurahPickerOpen] = useState(false);
  const [search, setSearch] = useState('');
  const pickerRef = useRef<HTMLDivElement>(null);
  const searchRef = useRef<HTMLInputElement>(null);

  const currentSurah = SURAHS.find((s) => s.number === selectedSurah);
  const isFirst = selectedAyah <= 1;
  const isLast = selectedAyah >= totalAyahs;

  // Close picker on outside click
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target as Node)) {
        setSurahPickerOpen(false);
        setSearch('');
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  // Focus search when picker opens
  useEffect(() => {
    if (surahPickerOpen && searchRef.current) {
      searchRef.current.focus();
    }
  }, [surahPickerOpen]);

  const clearState = () => {
    dispatch(clearEvaluation());
    dispatch(resetRecitation());
  };

  const handleSurahSelect = (surahNumber: number) => {
    setSurahPickerOpen(false);
    setSearch('');
    clearState();
    dispatch(loadAyah({ surah: surahNumber, ayah: 1 }));
  };

  const handlePrev = () => {
    if (selectedAyah > 1) {
      clearState();
      dispatch(loadAyah({ surah: selectedSurah, ayah: selectedAyah - 1 }));
    }
  };

  const handleNext = () => {
    if (selectedAyah < totalAyahs) {
      clearState();
      dispatch(loadAyah({ surah: selectedSurah, ayah: selectedAyah + 1 }));
    }
  };

  const filteredSurahs = search
    ? SURAHS.filter(
        (s) =>
          s.name.toLowerCase().includes(search.toLowerCase()) ||
          String(s.number).includes(search)
      )
    : SURAHS;

  return (
    <div className="flex items-center justify-between gap-2">
      {/* Prev button */}
      <button
        onClick={handlePrev}
        disabled={isFirst || loading}
        className="p-2 rounded-xl text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
        title="Previous ayah"
      >
        <ChevronLeft />
      </button>

      {/* Center: surah name + ayah indicator */}
      <div className="flex flex-col items-center gap-1 min-w-0 relative" ref={pickerRef}>
        <button
          onClick={() => setSurahPickerOpen(!surahPickerOpen)}
          className="flex items-center gap-2 px-4 py-1.5 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
        >
          <span className="text-sm font-semibold text-gray-700 dark:text-gray-200 truncate">
            {currentSurah ? `${currentSurah.number}. ${currentSurah.name}` : `Surah ${selectedSurah}`}
          </span>
          <svg
            className={`w-3.5 h-3.5 text-gray-400 transition-transform ${surahPickerOpen ? 'rotate-180' : ''}`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {/* Ayah position */}
        {totalAyahs > 0 && (
          <div className="flex items-center gap-1">
            {totalAyahs <= 20 ? (
              <div className="flex gap-1">
                {Array.from({ length: totalAyahs }, (_, idx) => (
                  <button
                    key={idx}
                    onClick={() => {
                      clearState();
                      dispatch(loadAyah({ surah: selectedSurah, ayah: idx + 1 }));
                    }}
                    className={`w-2 h-2 rounded-full transition-all ${
                      idx + 1 === selectedAyah
                        ? 'bg-emerald-500 scale-125'
                        : idx + 1 < selectedAyah
                        ? 'bg-emerald-500/40'
                        : 'bg-gray-300 dark:bg-gray-600'
                    }`}
                    title={`Ayah ${idx + 1}`}
                  />
                ))}
              </div>
            ) : (
              <span className="text-xs text-gray-500 dark:text-gray-400">
                Ayah {selectedAyah} of {totalAyahs}
              </span>
            )}
          </div>
        )}

        {/* Surah picker dropdown */}
        {surahPickerOpen && (
          <div className="absolute top-full mt-2 z-50 w-72 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg shadow-black/10 dark:shadow-black/40 overflow-hidden">
            <div className="p-2">
              <input
                ref={searchRef}
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search surah..."
                className="w-full px-3 py-2 text-sm rounded-lg bg-gray-100 dark:bg-gray-700 border-none text-gray-900 dark:text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
            </div>
            <ul className="max-h-64 overflow-auto py-1">
              {filteredSurahs.map((s) => (
                <li
                  key={s.number}
                  onClick={() => handleSurahSelect(s.number)}
                  className={`px-4 py-2 text-sm cursor-pointer transition-colors flex items-center justify-between ${
                    s.number === selectedSurah
                      ? 'bg-emerald-600/10 text-emerald-600 dark:text-emerald-400'
                      : 'text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700'
                  }`}
                >
                  <span>
                    <span className="text-gray-400 dark:text-gray-500 mr-2">{s.number}.</span>
                    {s.name}
                  </span>
                  <span className="text-xs text-gray-400">{s.ayahs} ayahs</span>
                </li>
              ))}
              {filteredSurahs.length === 0 && (
                <li className="px-4 py-3 text-sm text-gray-400 text-center">No results</li>
              )}
            </ul>
          </div>
        )}
      </div>

      {/* Next button */}
      <button
        onClick={handleNext}
        disabled={isLast || loading}
        className="p-2 rounded-xl text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
        title="Next ayah"
      >
        <ChevronRight />
      </button>
    </div>
  );
};

export default AyahSelector;
